<template lang="pug">
  .tree-wrapper.packages-box-wrapper
    h1 Descargas
    .tree-categories(v-if="me && anySubscribed")
      ParentPackage(
        :item="item"
        :me="me"
        v-for="item in tree"
        v-if="item.subscribed || item.free"
        :key="item.pk"
      )
    .wrapper-no-subscribed-packages(v-if="!anySubscribed")
      h2 Actualmente no dispone de ninguna subscripción a ningún módulo para poder acceder a las descargas
</template>

<script type="text/javascript">
import _ from "underscore";
import api from "@/service/api";
import ParentPackage from "@/components/ParentPackage";
import { mapState } from "vuex";

export default {
  name: "Packages",
  components: {
    ParentPackage,
  },
  computed: mapState([
    "token", "username",
  ]),
  data() {
    return {
      tree: [],
      me: null,
      anySubscribed: false,
    };
  },
  async created() {
    const self = this
    const responseMe = await api.me(this.token)
    this.me = responseMe.data
    const responseTree = await api.tree(this.token)
    this.tree = responseTree.data.tree
    _.each(this.tree, item => {
      if (item.subscribed || item.free) self.anySubscribed = true
    })
  },
};
</script>
